import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c6fb99a")

_pushScopeId("data-v-1c6fb99a")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex align-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "margin-right-10" }, "通用匹配分类:", -1)
const _hoisted_4 = { class: "flex align-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "margin-right-10" }, "通用匹配标签:", -1)
const _hoisted_6 = { class: "flex align-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "margin-right-10" }, "当前练习匹配标签:", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("选择音频")
const _hoisted_9 = {
  key: 2,
  class: "margin-top-10 flex-center"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("自动匹配")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_demo_list = _resolveComponent("demo-list")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isEditing && _ctx.mindUpMatchRule)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_el_breadcrumb, {
              class: "margin-left-10",
              style: {"line-height":"unset"},
              separator: "/"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryPath, (item) => {
                  return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: item }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mindUpMatchRule.tags, (tag) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: tag.id
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(tag.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.practice.matchTags, (tag) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: tag.id
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(tag.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mindUpMatchRule)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 1,
          data: _ctx.practice.audios,
          style: {"width":"100%"}
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.practice.options, (option) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                width: "100px",
                key: option.code,
                label: option.name
              }, {
                default: _withId(({row}) => [
                  (row[option.code])
                    ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(row[option.code].name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128)),
            _createVNode(_component_el_table_column, {
              prop: "audio",
              label: "音频"
            }, {
              default: _withId(({row}) => [
                _createVNode("audio", {
                  controls: "",
                  src: row.audio
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "demoName",
              "show-tooltip-when-overflow": "",
              label: "成品名称"
            }),
            (_ctx.isEditing)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  fixed: "right",
                  label: "操作",
                  width: "140"
                }, {
                  default: _withId(({row}) => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.selectDemo(row))
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true),
    (_ctx.isEditing)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _ctx.autoMatch
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submit
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.cancel
          }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "选择音频",
      top: "10px",
      modelValue: _ctx.demoSelectedDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.demoSelectedDialogVisible = $event)),
      width: "80%"
    }, {
      default: _withId(() => [
        _createVNode(_component_demo_list, {
          queryParams: _ctx.currentQueryParams,
          onDemoSelected: _ctx.demoSelected,
          isSelectorMode: true
        }, null, 8, ["queryParams", "onDemoSelected"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})